/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_line_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create a line chart from pasted data — track trends over time, no sign-up.`)
};

const es_line_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea un gráfico de líneas a partir de datos pegados — sigue tendencias a lo largo del tiempo, sin registro.`)
};

const de_line_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstellen Sie ein Liniendiagramm aus eingefügten Daten — verfolgen Sie Trends über die Zeit, keine Anmeldung erforderlich.`)
};

const nl_line_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maak een lijndiagram van geplakte data — volg trends over tijd, geen registratie nodig.`)
};

const fr_line_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créez un graphique en courbes à partir de données collées — suivez les tendances dans le temps, sans inscription.`)
};

const it_line_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea un grafico a linee dai dati incollati — traccia le tendenze nel tempo, senza registrazione.`)
};

const pt_br2_line_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crie um gráfico de linhas a partir de dados colados — acompanhe tendências ao longo do tempo, sem cadastro.`)
};

const pt_line_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crie um gráfico de linhas a partir de dados colados — acompanhe tendências ao longo do tempo, sem registo.`)
};

const ja_line_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`貼り付けたデータから折れ線グラフを作成します — 時系列の傾向を追跡、登録不要。`)
};

const zh_line_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`根据粘贴的数据创建折线图——追踪随时间变化的趋势，无需注册。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const line_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.line_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("line_tool_description", locale)
	if (locale === "en") return en_line_tool_description(inputs)
	if (locale === "es") return es_line_tool_description(inputs)
	if (locale === "de") return de_line_tool_description(inputs)
	if (locale === "nl") return nl_line_tool_description(inputs)
	if (locale === "fr") return fr_line_tool_description(inputs)
	if (locale === "it") return it_line_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_line_tool_description(inputs)
	if (locale === "pt") return pt_line_tool_description(inputs)
	if (locale === "ja") return ja_line_tool_description(inputs)
	return zh_line_tool_description(inputs)
};